import { useTranslation } from "react-i18next";
import { Button, Icon, Loader, Modal } from "semantic-ui-react";

import { DATE_FORMATS_FNS } from "components";
import { useImportLogQuery } from "modules/DealersDashboard/components/DealersDashboardTable/components/DealerLocationsTable/components/ImportLogModal/hooks";
import { formatDate } from "utils/dateHelperFunctions";

import type { DealerLocationID } from "models";

type ImportLogModalProps = {
  locationId: DealerLocationID;
  dealerName: string;
  locationName: string;
  onClose: () => void;
};

export const ImportLogModal = ({ locationId, dealerName, locationName, onClose }: ImportLogModalProps) => {
  const { t } = useTranslation();

  const { data: importLogs, isFetching } = useImportLogQuery(locationId);
  const lastImportAt = importLogs?.[0]?.created_on;

  return (
    <Modal open size="small" closeOnDimmerClick={false} onClose={onClose} className="DealersDashboardModal">
      <Modal.Header>
        <div className="header-title">{`${dealerName} - ${locationName} ${t("v8_import_log", "Import Log")}`}</div>
        <Button className="modal-close-btn" basic onClick={onClose}>
          <Icon className="xmark" />
        </Button>
      </Modal.Header>
      <Modal.Content scrolling>
        {!!lastImportAt && (
          <div className="last-import">
            {`${t("v8_last_import", "Last import")}: `}
            <strong>{formatDate(lastImportAt, DATE_FORMATS_FNS.dateMonthYearDotAtTime)}</strong>
          </div>
        )}
        {isFetching && <Loader active inline="centered" size="small" />}
        {!isFetching && !importLogs?.length && <p>{t("v8_no_data_available", "No data available")}</p>}
        {!isFetching &&
          importLogs?.map(importLog => (
            <div className="row" key={importLog.import_log_id}>
              <span>{`${t("v8_wo", "WO")}: ${importLog.wo_nr}`}</span>
              <span>{`${t("v8_external_id", "External ID")}: ${importLog.external_id}`}</span>
            </div>
          ))}
      </Modal.Content>
    </Modal>
  );
};
